import { useSelector, useDispatch } from "react-redux";

import { CATEGORIES, TAGS } from "../../constants/store";
import { setExpandToolsMenu } from "../../redux/windowSlice";

import { DropDownElement } from "./DropDownElement";

export const ToolsDropDown = ({ value, dropdownItems, onClick }) => {
  const dispatch = useDispatch();
  const isStoreAdmin = useSelector(
    (state) => state?.user?.user?.is_store_admin
  );
  const toolsExpanded = useSelector((state) => state.window.toolsExpanded);
  const label = toolsExpanded ? "-" : "+";

  const dropdaownList = isStoreAdmin
    ? dropdownItems
    : dropdownItems.filter(
        ({ label }) => label !== TAGS && label !== CATEGORIES
      );

  const show = () => {
    dispatch(setExpandToolsMenu(!toolsExpanded));
  };

  return (
    <div className="dropdown-root">
      <div className="dropdown-placeholder" onClick={show} name="dropdown">
        {value}
        <span className="dropdown-label">{label}</span>
      </div>
      {toolsExpanded && (
        <div className="dropdown-menu">
          {dropdaownList.map((item) => (
            <DropDownElement key={item.link} item={item} onClick={onClick} />
          ))}
        </div>
      )}
    </div>
  );
};
